module.exports = __webpack_public_path__ + "img/Grooming.e2bd7356.svg";